import Dictionary from '@/types/dictionary';
import Fund from '@/types/fund';
import RebalanceFrequency from '@/types/rebalance-frequency';
import Stock from '@/types/stock';
import { TIME_PERIODS } from '@/utils/constants';

export const MAX_CAPITAL = 1000000000;

export type GrowthChartState = {
  capital: number;
  targetROI?: number;
  dateQuickRange: TIME_PERIODS;
  startDate: Date | null;
  endDate: Date;
  isYTD?: boolean;
  useMonthly?: boolean;
  rebalancePeriod?: RebalanceFrequency;
};

export type DrawdownChartState = {
  startDate: Date | null;
  endDate: Date;
  dateQuickRange: TIME_PERIODS;
  useMonthly?: boolean;
};

export type RiskRewardChartState = {
  monthsRange: number;
  dateQuickRange: TIME_PERIODS;
};

export type ExpandedPortfoliosData = Dictionary<{
  funds: Dictionary<Fund>;
  stocks: Dictionary<Stock>;
}>;
